import { render, staticRenderFns } from "./sublessorCompany.vue?vue&type=template&id=6f8b3d5e&scoped=true"
import script from "./sublessorCompany.vue?vue&type=script&lang=js"
export * from "./sublessorCompany.vue?vue&type=script&lang=js"
import style0 from "./sublessorCompany.vue?vue&type=style&index=0&id=6f8b3d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8b3d5e",
  null
  
)

export default component.exports